// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionsTab_wrapper__EE6Pv"};